<div class="main-panel" (keyup.enter)="Login()">
  <!-- BEGIN : Main Content-->
  <div class="main-content">
    <div class="content-overlay"></div>
    <div class="content-wrapper" style="padding: unset">
      <!--Login Page Starts-->
      <div class="content">
        <div class="content-wrapper">
          <div class="container" id="logincontainer">
            <div class="row">
              <div class="col-md-12 col-lg-6 col-sm-12 col-xs-12 hide-mobile">
                <img src="assets/images/app_images/loginbg.png" alt="Image" class="img-fluid">
              </div>
              <div class="col-md-12 col-lg-6 col-sm-12 col-xs-12 contents">
                <!--Patient Login-->
                <div *ngIf="LoginType == 'patient'">
                  <div class="row justify-content-center">
                    <div class="col-md-8">
                      <div class="mb-3">
                        <div class="d-flex">
                          <div class="">
                            <h5>Patient Login</h5>
                          </div>
                          <div class="ml-auto"><img width="100" class="img-fluid show-mobile"
                              src="assets/images/app_images/logo.png" class="mx-auto d-block">
                          </div>
                        </div>
                      </div>
                        <input type="text" name="email" autocomplete="off" class="form-control pl-3"  placeholder="Enter The Mobile Number" id="mobilenumber"
                          [(ngModel)]="patientmobilenumber" required [disabled]="showPasswordField" maxlength="10"
                           pattern="^[0-9]*$" style="width: 100%;  position: relative;
                          background-color: #edf2f5;
                          border: 1px solid #e6edf1;font-size: 15px;display:block;color: #0e0d0d;;padding:27px 5px 27px 0px; border: none;border-top-left-radius: 5px;border-top-right-radius: 5px; font-family: 'Roboto', sans-serif;" />
                     
                      <div class="mb-2" style="text-align: right;height : 2rem;">
                        <span class="change_email_mobile mb-1 pt-2" *ngIf="showPasswordField"
                          (click)="changeEmailOrMobile()" style="float: left;">Change Mobile Number</span>
                      </div>
                      <!-- <div class="form-group last mb-3">
                      <label for="password">Enter OTP</label>
                      <input type="password" name="password" *ngIf="showPasswordField" autocomplete="off"
                      class="form-control" [(ngModel)]="UserOTP" required maxlength="4"
                      minlength="3" style="width: 100%" />
                    </div> -->
                    <!-- <div class="form-group last mb-3" style="display: flex;">
                      <input [type]="showPassword ? 'text' : 'password'"  [(ngModel)]="Password" type="password" class="form-control" autocomplete="off" placeholder="Password"/>
                      
                    </div> -->
                    <div class="form-group last mb-3" style="display: flex; height: 3rem;" *ngIf="showPasswordField">
                      <input [type]="showPassword ? 'text' : 'password'" type="password" name="password" *ngIf="showPasswordField" autocomplete="off"
                        class="otp-section form-control mb-3 pl-3" placeholder="Enter OTP" [(ngModel)]="UserOTP" required
                        maxlength="6" minlength="3" style="width: 100%;  position: relative;
                          background-color: #edf2f5;
                          border: 1px solid #e6edf1;font-size: 15px;display:block;color: #b3b3b3; border: none;border-top-left-radius: 5px;border-top-right-radius: 5px; font-family: 'Roboto', sans-serif; margin-top: 4px;" />
                      <button 
                      type="button" 
                      class=" btn-outline-secondary" style="border: none;"
                      (click)="togglePasswordVisibility()">
                      <i [class]="showPassword ? 'fa fa-eye-slash' : 'fa fa-eye'"></i>
                      </button>
                       </div>
                       <span class="change_email_mobile mb-1" *ngIf="showPasswordField"
                       (click)="continueButtonClick()" style="position: relative;top: -8px;">Resend OTP</span>

                      <div class="d-flex mb-3 align-items-center ml-auto">
                        <div class="custom-control custom-checkbox" *ngIf="showPasswordField" style="margin-top: -3px">
                          <input type="checkbox" id="customCheckboxInline1" name="customCheckboxInline1"
                            class="custom-control-input" checked="true" />
                          <label class="custom-control-label" for="customCheckboxInline1">
                            I accept disclaimer
                          </label>
                        </div>

                        <span id="readdisclaimer" data-toggle="collapse" data-target="#demo"
                          class="ml-auto text-success">Read
                          Disclaimer</span>
                          <div>
                        </div>
                      </div>
                      <!-- <a class="text-decoration-none text-white" (click)="Login()" style="text-decoration:none;">
                      <input type="button" id="reportlogin" value="View&nbsp;Reports" class="btn btn-block btn-primary">
                    </a> -->
                      <a class="text-decoration-none text-white" (click)="continueButtonClick()"
                        style="text-decoration:none;" *ngIf="!showPasswordField">
                        <input  type="button" id="reportlogin" value="View&nbsp;Reports"
                          class="btn btn-block btn-primary" >
                      </a>
                      <a class="text-decoration-none text-white" (click)="continueButtonClick()"
                        style="text-decoration:none;" *ngIf="showPasswordField">
                        <input  type="button" id="reportlogin" value="View&nbsp;Reports"
                          class="btn btn-block btn-primary" >
                      </a>

                      <!-- <button *ngIf="showPasswordField" class="btn btn-primary"
                      style="color: white !important; margin-top: -5px" (click)="continueButtonClick(true)">
                      Continue
                    </button> -->
                    </div>
                  </div>
                </div>



                <!--Organisation Section-->
                <div *ngIf="LoginType == 'organisation'">
                  <div class="row justify-content-center">
                    <div class="col-md-8">
                      <div class="mb-3">
                        <div class="d-flex">
                          <div class="">
                            <h5>Organisation Login</h5>
                          </div>
                          <div class="ml-auto"><img width="100" class="img-fluid show-mobile"
                              src="assets/images/app_images/logo.png" class="mx-auto d-block"></div>
                        </div>
                      </div>
                      <div class="form-group first mb-4">
                        <!-- <label for="username"></label> -->
                        <input [(ngModel)]="UserId" type="text" class="form-control" autocomplete="off"  placeholder="Username"/>
                      </div>
                      <!-- <div class="form-group last mb-3">
                        <input [(ngModel)]="Password" type="password" class="form-control" autocomplete="off" placeholder="Password"/>
                      </div> -->
                      <div class="form-group last mb-3" style="display: flex;">
                        <!-- <label for="password">Password</label> -->
                        <input [type]="showPassword ? 'text' : 'password'"  [(ngModel)]="Password" type="password" class="form-control" autocomplete="off" placeholder="Password"/>
                        <button 
                          type="button" 
                          class=" btn-outline-secondary" style="border: none;"
                          (click)="togglePasswordVisibility()">
                          <i [class]="showPassword ? 'fa fa-eye-slash' : 'fa fa-eye'"></i>
                        </button>
                      </div>
                      <div class="d-flex mb-3 align-items-center ml-auto">
                        <div class="custom-control custom-checkbox">
                          <input type="checkbox" class="custom-control-input" id="customCheckboxlogin"
                            name="customCheckboxlogin" checked="true">
                          <label class="custom-control-label" for="customCheckboxlogin">I accept disclaimer
                          </label>
                        </div>
                        <span id="readdisclaimer" data-toggle="collapse" data-target="#demo"
                          class="ml-auto text-success">Read
                          Disclaimer</span>
                      </div>
                      <a class="text-decoration-none text-white" (click)="Login()" style="text-decoration:none;">
                        <input type="button" id="reportlogin" value="View&nbsp;Reports"
                          class="btn btn-block btn-primary">
                      </a>
                    </div>
                  </div>
                </div>
              </div>
              <!-- Disclaimer Section-->
              <div class="col-md-12 contents">
                <div id="demo" class="collapse text-center">
                  <div class="quote-wrapper">
                    <div class="disclaimerquotes">
                      <h4>Disclaimer:</h4>
                      This information in this portal is copied from the LIS/RIS/PACS platform which is dedicated
                      to
                      providing
                      the highest quality information. Please ensure that each report is reviewed by a physician
                      with
                      right
                      expertise in the area presented for further treatment and diagnosis. However, it is not
                      possible to
                      assure that this portal contains complete, up-to-date information, please seek a hardcopy
                      report
                      from
                      the diagnostic center for complete information and reports. Hardcopy reports are final
                      reports given
                      by
                      the respective physician. Therefore, We make no representations or warranties about the
                      suitability
                      of
                      this information for use for any particular purpose. All information is provided "as is"
                      without
                      express
                      or implied warranty
                      <!-- <h4>This solution was brought to you by </h4>
                      <img src="./assets/images/app_images/innowave-logo.png" alt="Image" class="img-fluid" style="margin-top: -12px;"> -->
                      <h6 class="pt-1">&copy;<a id="copyrights" target="_blank"
                          href="https://aarthiscan.com/">aarthiscan.com</a></h6>
                    </div>
                  </div>
                </div>
              </div>
              <div class="col-md-12" class="align-middle text-center">
                <h4 class="innowave">This solution was brought to you by</h4>
                <img src="./assets/images/app_images/innowave-logo.png" alt="Image" class="img-fluid" style="margin-top: -12px;">
              </div>

            </div>
          </div>
        </div>
      </div>
      <!--Login Page Ends-->
    </div>
  </div>